<template>
  <router-link :to="link" class="t-btn-green">
    <template v-if="!isMobile">
      {{ name }}
    </template>
    <template v-else>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 12L3 12M17 16L21 12L17 16ZM21 12L17 8L21 12Z"
          stroke="#00b0bd"
          stroke-width="1.68"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>
  </router-link>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'btn-green',
  props: ['link', 'name'],
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/btn-green/btn-green.vue